// extracted by mini-css-extract-plugin
export default {"brandLibrary":"BrandsLibrary_brandLibrary__RQk+8"};